export default __webpack_public_path__ + "static/media/video-img3.8a420671.jpg";